export default __webpack_public_path__ + "static/media/Diamond_Edge_large_1.a0586b59.jpg";